var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPillImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 95,
    height: 95,
    rx: 7.5,
    stroke: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 34H68M62 28V40M66 47V62C66 63.0609 65.5786 64.0783 64.8284 64.8284C64.0783 65.5786 63.0609 66 62 66H34C32.9391 66 31.9217 65.5786 31.1716 64.8284C30.4214 64.0783 30 63.0609 30 62V34C30 32.9391 30.4214 31.9217 31.1716 31.1716C31.9217 30.4214 32.9391 30 34 30H49M66 54L59.828 47.828C59.0779 47.0781 58.0607 46.6569 57 46.6569C55.9393 46.6569 54.9221 47.0781 54.172 47.828L36 66M46 42C46 44.2091 44.2091 46 42 46C39.7909 46 38 44.2091 38 42C38 39.7909 39.7909 38 42 38C44.2091 38 46 39.7909 46 42Z",
    stroke: "#A3A3A3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPillImg);
export default __webpack_public_path__ + "static/media/icon_pill_img.dabbecd37eedf4eb1344016461a984c8.svg";
export { ForwardRef as ReactComponent };